import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT, waLink, telLink } from "../lib/execora";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);

    onScroll();

    window.addEventListener("scroll", onScroll, {
      passive: true,
    });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navigateToSection = (sectionId) => {
    if (location.pathname === "/") {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      return;
    }

    navigate("/");

    setTimeout(() => {
      document.getElementById(sectionId)?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 150);
  };

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-white/75 backdrop-blur-xl border-b border-slate-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">

        {/* Logo */}
        <Link
          to="/"
          data-testid="header-logo-link"
          className="flex items-center"
        >
          <Logo />
        </Link>

        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-8 text-sm text-slate-600">

          <button
            type="button"
            onClick={() => navigateToSection("use-cases")}
            className="hover:text-slate-900 transition-colors"
          >
            Services
          </button>

          <button
            type="button"
            onClick={() => navigateToSection("how-it-works")}
            className="hover:text-slate-900 transition-colors"
          >
            How it works
          </button>

          <button
            type="button"
            onClick={() => navigateToSection("service-area")}
            className="hover:text-slate-900 transition-colors"
          >
            Locations
          </button>

          <button
            type="button"
            onClick={() => navigateToSection("about")}
            className="hover:text-slate-900 transition-colors"
          >
            About
          </button>

        </nav>

        {/* CTA */}
        <div className="flex items-center gap-2">

          <a
            href={telLink()}
            data-testid="header-call-cta"
            aria-label={`Call ${CONTACT.callDisplay}`}
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium text-slate-700 border border-slate-200 hover:border-slate-300 hover:bg-slate-50 transition-colors"
          >
            <Phone className="h-4 w-4" strokeWidth={2} />
            Call
          </a>

          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-cta"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium text-white bg-[#84cc15] hover:bg-[#65a30d] shadow-sm transition-colors"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M19.11 17.24c-.28-.14-1.66-.82-1.92-.92-.26-.1-.45-.14-.64.14s-.73.92-.9 1.11c-.17.19-.33.21-.61.07-.28-.14-1.19-.44-2.27-1.41-.84-.75-1.4-1.67-1.57-1.95-.16-.28-.02-.43.12-.57.13-.13.28-.33.42-.5.14-.17.19-.28.28-.47.1-.19.05-.36-.02-.5-.07-.14-.64-1.54-.87-2.1-.23-.55-.46-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.28-1 .98-1 2.39 0 1.41 1.02 2.78 1.17 2.98.14.19 2.02 3.08 4.9 4.32.68.29 1.22.47 1.64.6.69.22 1.31.19 1.8.12.55-.08 1.66-.68 1.9-1.34.24-.66.24-1.22.17-1.34-.07-.12-.26-.19-.54-.33zM12.05 2C6.5 2 2 6.5 2 12.03c0 1.9.5 3.76 1.46 5.4L2 22l4.71-1.43A9.98 9.98 0 0 0 12.05 22C17.6 22 22.1 17.5 22.1 11.97 22.1 6.44 17.6 2 12.05 2z" />
            </svg>

            <span className="hidden sm:inline">
              WhatsApp
            </span>

            <span className="sm:hidden">
              Order
            </span>
          </a>

        </div>

      </div>
    </header>
  );
};

export default Header;
